import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import audio from '../../utils/audio';
import PlayerInterface from '../../api/PlayerInterface';
import { openTermsAndConditionsByURL } from '../../utils/termsAndConditions';
import { getText, TEXT_KEY } from '../../utils/localization';

var UpdateTerms = /*#__PURE__*/function (_Component) {
  _inherits(UpdateTerms, _Component);

  var _super = _createSuper(UpdateTerms);

  function UpdateTerms(props) {
    var _this;

    _classCallCheck(this, UpdateTerms);

    _this = _super.call(this, props);

    _this.setTerms = function () {
      audio.onClick();

      _this.setState({
        terms: !_this.state.terms
      });
    };

    _this.onSubmit = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var acceptRes;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              audio.onClick();
              _context.prev = 1;
              _context.next = 4;
              return PlayerInterface.acceptNewTerms();

            case 4:
              acceptRes = _context.sent;

              if (acceptRes[0]) {
                _this.props.setUpdatedTermsState(false);
              } else {
                _this.setState({
                  error: getText(TEXT_KEY.UPDATE_TERMS_ERROR)
                });
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);

              _this.setState({
                error: _context.t0.message
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));

    _this.checkSelectedTerms = function (item) {
      if (!openTermsAndConditionsByURL(_objectSpread(_objectSpread({}, _this.props), {}, {
        item: item
      }))) {
        _this.setState({
          selectedTerms: item ? item : null,
          disableClose: !_this.state.disableClose
        });
      }
    };

    _this.state = {
      terms: false,
      error: '',
      selectedTerms: null,
      disableClose: true
    };
    return _this;
  }

  _createClass(UpdateTerms, [{
    key: "render",
    value: function render() {
      return this.props.render(_objectSpread(_objectSpread({}, this.props), {}, {
        checkSelectedTerms: this.checkSelectedTerms,
        selectedTerms: this.state.selectedTerms,
        disableClose: this.state.disableClose,
        onSubmit: this.onSubmit,
        setTerms: this.setTerms,
        terms: this.state.terms,
        error: this.state.error
      }));
    }
  }]);

  return UpdateTerms;
}(Component);

export { UpdateTerms as default };